var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.633 0.710001C13.243 0.320001 12.613 0.320001 12.223 0.710001L7.33298 5.59L2.44298 0.700001C2.05298 0.310001 1.42298 0.310001 1.03298 0.700001C0.642979 1.09 0.642979 1.72 1.03298 2.11L5.92298 7L1.03298 11.89C0.642979 12.28 0.642979 12.91 1.03298 13.3C1.42298 13.69 2.05298 13.69 2.44298 13.3L7.33298 8.41L12.223 13.3C12.613 13.69 13.243 13.69 13.633 13.3C14.023 12.91 14.023 12.28 13.633 11.89L8.74298 7L13.633 2.11C14.013 1.73 14.013 1.09 13.633 0.710001Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSymbol);
export default __webpack_public_path__ + "static/media/close-symbol.9e831ca0ea741b981291bfccb98cb99d.svg";
export { ForwardRef as ReactComponent };